import React, { useState } from 'react';

import { getConfig } from '@klpkonsern/appconfig';
import { TrustedIframe } from '@klp/iframe';

const SocialMediaWidget = () => {
    const taggBoxURL = getConfig('WEBAPP_TAGGBOX_URL', '');
    const [isFullscreen, setIsFullscreen] = useState(false);

    if (!taggBoxURL) return null;

    // Generate HTML content for Taggbox widget to run in isolated iframe
    const taggboxContent = `
        <!DOCTYPE html>
        <html>
        <head>
            <meta charset="UTF-8">
            <meta name="viewport" content="width=device-width, initial-scale=1.0">
            <style>
                body {
                    margin: 0;
                    padding: 0;
                    overflow-x: hidden;
                    overflow-y: hidden;
                }
                .taggbox-container {
                    width: 100%;
                }
            </style>
        </head>
        <body>
            <div class="taggbox-container" id="taggbox-container">
                <div 
                    class="taggbox-socialwall" 
                    data-wall-id="${taggBoxURL.slice(-5)}"
                    view-url="${taggBoxURL}">
                </div>
            </div>
            <script src="https://widget.taggbox.com/embed.min.js" async></script>
            <script>
                // Notify parent of initial height once content is loaded
                function notifyInitialHeight() {
                    const container = document.getElementById('taggbox-container');
                    if (!container) {
                        setTimeout(notifyInitialHeight, 100);
                        return;
                    }
                    
                    window.parent.postMessage({
                        height: container.scrollHeight
                    }, '*');
                }

                // Wait for Taggbox content to load, then notify
                setTimeout(notifyInitialHeight, 2000);
            </script>
        </body>
        </html>
    `;

    const handleExitFullscreen = () => {
        setIsFullscreen(false);
    };

    return (
        <>
            <TrustedIframe
                content={taggboxContent}
                autoHeight={true}
                fullScreen={isFullscreen}
                data-testid="SocialMediaWidget__Iframe"
            />
            {isFullscreen && (
                <button
                    onClick={handleExitFullscreen}
                    style={{
                        position: 'fixed',
                        top: 20,
                        right: 20,
                        zIndex: 9999,
                        padding: '10px 20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        color: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer',
                    }}
                >
                    Exit Fullscreen
                </button>
            )}
        </>
    );
};

export default SocialMediaWidget;
